import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance } from './instance'

export default class StickerSourceManagementService {
  // 获取元数据来源系统
  static async getSourceSystems(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataManage/source-systems?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取元数据表
  static async getSourceTables(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataManage/source-tables?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取元数据字段
  static async getTableColumns(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataManage/table-columns?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取采集表数据
  static async getTCollectTableDatas(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataManage/collect-table-datas?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取元数据采集任务运行记录
  static async taskRunRecords(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataManage/task-run-records?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 删除元数据采集任务运行记录
  static async deleteTaskRunRecords(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/MetaDataManage/task-run-records', { data: payload })
    )
    return Callback(err, res)
  }
}
